module.exports = __webpack_public_path__ + "img/forbes.1ebbd58d.svg";